import CheckBox from './CheckBox'

import './style.scss'

export { CheckBox }
export default CheckBox
